import { isRef, onBeforeUnmount, watch } from 'vue';
import { useAuthStore } from '@/stores/useAuthStore';

export function openDemoPaywall(event) {
  if (event?.type === 'keydown' && ['Tab', 'Shift', 'Control', 'Alt', 'Meta', 'Escape'].includes(event.key)) return;
  event?.preventDefault();
  event?.stopImmediatePropagation();
  window.dispatchEvent(new CustomEvent('entitlement:missing', { detail: { demo: true } }));
}

/** Tab-scoped input only: no account data, payment authorization or automatic submission. */
export function useDemoDraft(tool, fields, { enabled = true } = {}) {
  const auth = useAuthStore();
  const key = `pf_demo_draft:${tool}`;
  let active = false;
  let retained = false;
  const save = () => {
    if (!enabled || !active || (auth.isAuthenticated && !retained)) return;
    try {
      sessionStorage.setItem(key, JSON.stringify(Object.fromEntries(
        Object.entries(fields).map(([name, source]) => [name, isRef(source) ? source.value : source])
      )));
    } catch { /* A blocked storage area must not break the form. */ }
  };
  const restore = () => {
    if (!enabled) return;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
        Object.entries(fields).forEach(([name, target]) => {
          if (!(name in saved)) return;
          if (isRef(target)) target.value = target.value instanceof Date ? new Date(saved[name]) : saved[name];
          else if (saved[name] && typeof saved[name] === 'object') Object.assign(target, saved[name]);
        });
        retained = true;
      }
    } catch { sessionStorage.removeItem(key); }
    active = true;
  };
  watch(() => Object.values(fields).map(source => isRef(source) ? source.value : source), save, { deep: true });
  onBeforeUnmount(save);
  const clear = () => { active = false; retained = false; sessionStorage.removeItem(key); };
  return { restore, clear };
}
